<template>
  <div class="h-full w-full">
    <el-input
      placeholder="请输入关键词"
      v-model="keyword"
      size="small"
      clearable
      @keypress.enter.native="searchTableData"
      class="icon-search__input my-5px"
    >
      <i
        slot="append"
        class="el-icon-search cursor-pointer icon-search__input"
        @click="searchTableData"
      ></i>
    </el-input>
    <el-table
      :data="tableData"
      highlight-current-row
      class="!h-[calc(100%-84px)] !w-full mb-10px"
      ref="tableRef"
      v-loading="tableLoading"
    >
      <el-table-column label="" width="15">
        <template>
          <div class="selected-row"></div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        :label="it.label"
        :prop="it.prop"
        v-for="(it, index) in columnList"
        :key="index"
      >
        <template slot-scope="scope">
          <div
            v-if="it.type === 'ThreeDimensional'"
            @click="moveThreeD(scope.row)"
            class="cursor-pointer text-hex-00bcc8 truncate w-full"
          >
            {{ scope.row[it.prop] }}
          </div>
          <div v-else class="truncate w-full">{{ scope.row[it.prop] }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="50">
        <template slot-scope="{ row }">
          <div @click="lookDetail(row)" class="cursor-pointer text-hex-00bcc8">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @size-change="getTableData"
      @current-change="getTableData"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :pager-count="5"
      layout="total, prev, pager, next"
      :total="page.total"
      class="text-center"
    ></el-pagination>
    <MetalBimDetail
      v-if="metalBimDetailVisbal"
      @close="metalBimDetailVisbal = false"
      :title="currentMetalTitle"
      :bimDetail="bimDetail"
      :type="currentMetalType"
    ></MetalBimDetail>
  </div>
</template>

<script>
import { MetalBIMApi } from '@wiz-api/huizhou2'
import { forEach, isArray, isEmpty } from 'lodash'
import { isJSONObj } from '../../../assets/js/scene/scene'

const MetalBimDetail = () => {
  return import('./MetalBimDetail')
}
const metalBIMApi = new MetalBIMApi()
export default {
  name: 'MetAlalertList',
  components: { MetalBimDetail },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {},
    },
    player: {
      type: Object,
      default: () => {},
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    customProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
      columnList: [],
      tableLoading: false,
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      keyword: '',
      currentTableName: '',
      metalBimDetailVisbal: false,
      bimDetail: {},
      currentMetalType: '',
      currentMetalTitle: '',
    }
  },
  watch: {
    transferProps: {
      handler(val) {
        this.currentTableName = val.name
        this.page.pageNo = 1
        this.metalBimDetailVisbal = false
        this.getTableData()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getTableData() {
      let res = null
      this.tableLoading = true
      switch (this.currentTableName) {
        case 'onlineCount': // 管道-在线-检验临期
          this.columnList = [
            { prop: 'prPipelineName', label: '管道名称', type: 'ThreeDimensional' },
            { prop: 'prOnlineInspectDueDate', label: '在线检验到期日' },
          ]
          this.currentMetalType = 'pressurePiping'
          this.currentMetalTitle = '压力管道'
          res = await metalBIMApi.getSpecialPressurePipeline(this.page.pageNo, this.page.pageSize, {
            isOnlineExpire: true,
            metalType: '压力管道',
            keyWord: this.keyword,
          })
          break
        case 'allCount': // 管道-全面-检验临期
          this.columnList = [
            { prop: 'prPipelineName', label: '管道名称', type: 'ThreeDimensional' },
            { prop: 'prAllInspectDueDate', label: '全面检验到期日' },
          ]
          this.currentMetalType = 'pressurePiping'
          this.currentMetalTitle = '压力管道'
          res = await metalBIMApi.getSpecialPressurePipeline(this.page.pageNo, this.page.pageSize, {
            isAllExpire: true,
            metalType: '压力管道',
            keyWord: this.keyword,
          })
          break
        case 'containerYearCount': // 压力容器-年度-检验临期
          this.columnList = [
            { prop: 'prContainerName', label: '设备名称', type: 'ThreeDimensional' },
            { prop: 'prYearInspectDueDate', label: '年度检验到期日' },
          ]
          this.currentMetalType = 'pressureVessels'
          this.currentMetalTitle = '压力容器'
          res = await metalBIMApi.getSpecialPressureContainer(
            this.page.pageNo,
            this.page.pageSize,
            {
              isYearExpire: true,
              metalType: '压力容器',
              keyWord: this.keyword,
            }
          )
          break
        case 'containerRegularCount': // 压力容器-定期-检验临期
          this.columnList = [
            { prop: 'prContainerName', label: '设备名称', type: 'ThreeDimensional' },
            { prop: 'prRegularInspectDueDate', label: '定期检验到期日' },
          ]
          this.currentMetalType = 'pressureVessels'
          this.currentMetalTitle = '压力容器'
          res = await metalBIMApi.getSpecialPressureContainer(
            this.page.pageNo,
            this.page.pageSize,
            {
              isPeriodicalExpire: true,
              metalType: '压力容器',
              keyWord: this.keyword,
            }
          )
          break
        case 'innerCount': // 锅炉-内-检日临期
          this.columnList = [
            { prop: 'prBoilerName', label: '设备名称', type: 'ThreeDimensional' },
            { prop: 'prInnerInspectDueDate', label: '锅炉内检验到期日' },
          ]
          this.currentMetalType = 'boiler'
          this.currentMetalTitle = '锅炉'
          res = await metalBIMApi.getSpecialPressureBoiler(this.page.pageNo, this.page.pageSize, {
            isInnerExpire: true,
            metalType: '锅炉',
            keyWord: this.keyword,
          })
          break
        case 'outerCount': // 锅炉-外-检日临期
          this.columnList = [
            { prop: 'prBoilerName', label: '设备名称', type: 'ThreeDimensional' },
            { prop: 'prOuterIinspectDueDate', label: '锅炉外检验到期日' },
          ]
          this.currentMetalType = 'boiler'
          this.currentMetalTitle = '锅炉'
          res = await metalBIMApi.getSpecialPressureBoiler(this.page.pageNo, this.page.pageSize, {
            isOutExpire: true,
            metalType: '锅炉',
            keyWord: this.keyword,
          })
          break
        case 'suppportWarning': // 支吊架全面检测日临期
          this.columnList = [
            { prop: 'prName', label: '设备名称', type: 'ThreeDimensional' },
            { prop: 'prAllInspectDueDate', label: '全面检验到期日' },
          ]
          this.currentMetalType = 'supportHanger'
          this.currentMetalTitle = '支吊架'
          res = await metalBIMApi.getSupportHanger(this.page.pageNo, this.page.pageSize, {
            isAllExpire: true,
            metalType: '支吊架',
            keyWord: this.keyword,
          })
          break
        case 'cylinderRegularCount': // 压力气瓶定期检验临期
          this.columnList = [
            { prop: 'prEqNum', label: '设备编号', type: 'ThreeDimensional' },
            { prop: 'prRegularInspectDueDate', label: '定期检验到期日' },
          ]
          this.currentMetalType = 'pressureCylinders'
          this.currentMetalTitle = '压力气瓶'
          res = await metalBIMApi.getSpecialPressureCylinder(this.page.pageNo, this.page.pageSize, {
            isPeriodicalExpire: true,
            metalType: '压力气瓶',
            keyWord: this.keyword,
          })
          break
        case 'simpleRegularCount': // 简单压力容器定期检验临期
          this.columnList = [
            { prop: 'prContainerNum', label: '设备编号', type: 'ThreeDimensional' },
            { prop: 'prRegularInspectDueDate', label: '定期检验到期日' },
          ]
          this.currentMetalType = 'simplePressureVessels'
          this.currentMetalTitle = '简单压力容器'
          res = await metalBIMApi.getSpecialSimplePressureContainer(
            this.page.pageNo,
            this.page.pageSize,
            {
              isPeriodicalExpire: true,
              metalType: '简单压力容器',
              keyWord: this.keyword,
            }
          )
          break
        case 'safeCount': // 安全阀校验日临期
          this.columnList = [
            { prop: 'prReliefValveName', label: '安全阀名称', type: 'ThreeDimensional' },
            { prop: 'prInspectDueDate', label: '校验到期日期' },
          ]
          this.currentMetalType = 'reliefValve'
          this.currentMetalTitle = '安全阀'
          res = await metalBIMApi.getJsRelifeValue(this.page.pageNo, this.page.pageSize, {
            isCheckExpire: true,
            metalType: '安全阀',
            keyWord: this.keyword,
          })
          break
        default:
          break
      }
      if (res && res.length && !res[0]) {
        this.tableData = res[1].items
        this.page.total = res[1].totalCount
        this.tableLoading = false
        const metalModels = []
        forEach(this.tableData, (item) => {
          if (item.metalModels && !isEmpty(item.metalModels) && isArray(item.metalModels)) {
            forEach(item.metalModels, (subItem) => {
              metalModels.push(subItem)
            })
          }
        })
        if (metalModels && !isEmpty(metalModels)) {
          this.activeThreeDimensional(metalModels)
        } else {
          this.returnHome()
        }
      }
    },
    async moveThreeD(row) {
      const metalModels = row.metalModels
      if (metalModels && !_.isEmpty(metalModels)) {
        const allInfoArr = []
        await this.getAllInfo(0, metalModels, allInfoArr)
        if (isEmpty(allInfoArr)) {
          return
        }
        const allInfoArrItems = allInfoArr.map((it) => {
          return it.getDataInfo().item
        })
        this.cloudRender.NodeProxy.player.Native.ModelTree.setSelectItems(allInfoArrItems)
        const modelAabb = await this.getSceneAabb(allInfoArr)
        const mat = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
        await this.cloudRender.Camera.player.Native.Camera.addMoveToAabb(modelAabb, mat, 0, 1, 2)
      } else {
        await this.cloudRender.NodeProxy.removeSelectedItem() // 取消选中
        if (this.customProps.sceneOptions && isJSONObj(this.customProps.sceneOptions.jsonData)) {
          const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
          const cameraParams = isJSONObj(jsonData.cameraParams)
            ? JSON.parse(jsonData.cameraParams)
            : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
          const { eye, target, up } = cameraParams
          await this.cloudRender.Camera.moveCamera('CameraParam', { eye, target, up }) // 回到初始位置
        } else if (this.customProps.sceneOptions.isEnableGis) {
          await this.cloudRender.Camera.moveCamera('LLH', [
            this.customProps.sceneOptions.longitude,
            this.customProps.sceneOptions.latitude,
            50,
          ])
        } else {
          await this.cloudRender.Camera.moveCamera('CameraParam', {
            eye: [-1028, 580, 13821],
            target: [-1028, 579, 85],
            up: [0, 1, 0],
          })
        }
      }
    },
    // 获取场景aabb
    async getSceneAabb(nodes) {
      const aabbList = []
      for (let i = 0; i < nodes.length; i += 1) {
        const item = nodes[i]
        // eslint-disable-next-line no-await-in-loop
        const aabb = await this.cloudRender.NodeProxy.getAabb(item)
        if (aabb) {
          aabbList.push(aabb.data.aabb)
        }
      }
      const maxX = _.maxBy(aabbList, (item) => {
        return item[1][0]
      })
      const maxY = _.maxBy(aabbList, (item) => {
        return item[1][1]
      })
      const maxZ = _.maxBy(aabbList, (item) => {
        return item[1][2]
      })
      const minX = _.minBy(aabbList, (item) => {
        return item[0][0]
      })
      const minY = _.minBy(aabbList, (item) => {
        return item[0][1]
      })
      const minZ = _.minBy(aabbList, (item) => {
        return item[0][2]
      })
      return {
        max: [maxX[1][0], maxY[1][1], maxZ[1][2]],
        min: [minX[0][0], minY[0][1], minZ[0][2]],
      }
    },
    lookDetail(row) {
      this.metalBimDetailVisbal = true
      this.bimDetail = row
    },
    searchTableData() {
      this.page.pageNo = 1
      this.getTableData()
    },
    /**
     * @description 三维交互
     * @param {*} Array 三维高亮的数组
     */
    async activeThreeDimensional(arr) {
      const allInfoArr = []
      await this.getAllInfo(0, arr, allInfoArr)
      if (isEmpty(allInfoArr)) {
        this.returnHome()
        return
      }
      const allInfoArrItems = allInfoArr.map((it) => {
        return it.getDataInfo().item
      })
      this.cloudRender.NodeProxy.player.Native.ModelTree.setSelectItems(allInfoArrItems)
    },
    // 获取所有点位信息
    async getAllInfo(index, data, tempArr) {
      if (index < data.length) {
        const result = await this.cloudRender.NodeProxy.getInfo('Code', data[index].modelId)
        if (result.status) {
          tempArr.push(result.data)
        }
        await this.getAllInfo(index + 1, data, tempArr)
      }
    },
    // 返回主视角
    async returnHome() {
      await this.cloudRender.NodeProxy.removeSelectedItem()
      if (this.customProps.sceneOptions && isJSONObj(this.customProps.sceneOptions.jsonData)) {
        const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
        const cameraParams = isJSONObj(jsonData.cameraParams)
          ? JSON.parse(jsonData.cameraParams)
          : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
        const { eye, target, up } = cameraParams
        await this.cloudRender.Camera.moveCamera('CameraParam', { eye, target, up })
      } else if (this.customProps.sceneOptions.isEnableGis) {
        await this.cloudRender.Camera.moveCamera('LLH', [
          this.customProps.sceneOptions.longitude,
          this.customProps.sceneOptions.latitude,
          50,
        ])
      } else {
        await this.cloudRender.Camera.moveCamera('CameraParam', {
          eye: [-1028, 580, 13821],
          target: [-1028, 579, 85],
          up: [0, 1, 0],
        })
      }
    },
  },
  beforeDestroy() {
    this.returnHome()
    this.cloudRender.NodeProxy.removeSelectedItem() // 取消选中
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}
</style>
